
export default {
    name: "longformtextDefault",
    props:{
        content: Object
    }
}
